import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1 9.099h6c.6 0 1-.4 1-1s-.4-1-1-1H3.5l2.8-2.7c.8-.8 1.9-1.5 3-1.9 2-.7 4.2-.6 6.1.3s3.4 2.5 4.1 4.6c.2.5.8.8 1.3.6s.8-.8.6-1.3c-.9-2.5-2.7-4.5-5.1-5.7s-5.1-1.3-7.6-.4c-1.4.6-2.7 1.4-3.7 2.4l-3 2.8v-3.7c0-.6-.4-1-1-1s-1 .4-1 1v6.3c0 .1.1.1.1.2 0 0 0 .1.1.1.1.1.2.2.3.2.2.2.4.2.5.2m23 2.8v-.2c0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1-.1-.1-.1-.1-.2-.1l-.1-.1h-.1s-.2 0-.3-.1h-6c-.6 0-1 .4-1 1s.4 1 1 1h3.5l-2.8 2.7c-3.1 3.1-8.2 3.1-11.3 0-.8-.8-1.5-1.9-1.9-3-.2-.5-.8-.8-1.3-.6s-.8.8-.6 1.3c.5 1.4 1.3 2.7 2.4 3.7 2 2 4.5 2.9 7.1 2.9s5.1-1 7-2.9l3-2.8v3.7c0 .6.4 1 1 1s1-.4 1-1v-6c-.2-.1-.2-.1-.2-.2"
    }, null, -1)
  ]))]))
}
export default { render: render }